import { withTranslation } from 'react-i18next'
import Help from './Help'

export default withTranslation()(Help)
